import React from 'react';
import { Link } from 'react-router-dom';
import './GridMenu.scss';

const GridMenu = props => {
    const { menuData, parentMenu, updateNavDtm, section } = props;
    const fetchMenu = menuData.data.map((data, index) => {
        return (
            <div key={index} className="grid-menu">
                <div key={index} className="layout flex-column center" onClick={() => { updateNavDtm(section, '', '', data.url); }}>
                    {data.url && data.url.indexOf('lenskart.com') === -1 ?
                        <Link className="" to={{ pathname: data.url, state: { categoryId: data.categoryId, section: 'cat' } }}>
                            <div className="margin-b10">
                                <img src={data.img} alt={data.text} />
                            </div>
                            <div className="">{data.text}</div></Link> :
                        <a href={data.url} className="">
                            <div className="margin-b10">
                                <img src={data.img} alt={data.text} />
                            </div>
                            <div className="">{data.text}</div>
                        </a>}
                </div>
            </div >
        );
    });
    return (
        <div className={parentMenu.sliderType ? 'layout slider' : 'nav-level-acc'}>{fetchMenu}</div>
    );
};

export default GridMenu;
